import React, { useContext, useEffect, useMemo, useState } from 'react';
import { v4 } from 'uuid';
const noop = () => { };
const initialContext = { hasWarnings: false, warningState: {}, setWarningState: noop };
export const generateUUID = () => v4();
export const WarningContext = React.createContext(initialContext);
export const WarningProvider = ({ children }) => {
    const [warningState, setWarningState] = useState({});
    const hasWarnings = useMemo(() => Object.values(warningState).some(Boolean), [warningState]);
    const contextValue = { warningState, setWarningState, hasWarnings };
    return React.createElement(WarningContext.Provider, { value: contextValue }, children);
};
export const useWarningContext = () => useContext(WarningContext);
export const useFieldWarning = ({ warning, warningId }) => {
    const { setWarningState } = useWarningContext();
    const warningKey = useMemo(() => warningId || generateUUID(), []);
    useEffect(() => {
        setWarningState((prev) => {
            return { ...prev, [warningKey]: warning };
        });
        return () => {
            setWarningState((prev) => {
                const next = { ...prev };
                delete next[warningKey];
                return next;
            });
        };
    }, [warningKey, warning]);
};
//# sourceMappingURL=WarningProvider.js.map